export const AnimationType = {
  Animation: "animation",
  VideoAnim: "video",
  WideBoxWithAnim: "wide-box-with-anim",
  AnimWithoutFade: "anim-without-fade",
  VideoPlayer: "videoPlayer"
};
